<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.settings' | translate }}
    v-card-content
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :focus="true"
            :label="$t('base.first_name')"
            v-model="form.first_name")
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.email')"
            v-model="form.email")
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.last_name')"
            v-model="form.last_name")
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.phone')"
            v-model="form.phone")
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3.remove-margin-above-mobile
          v-text-field(
            :label="$t('base.company_name')"
            v-model="form.company_name")
        .cols-x__2.cols-x__2--offset-md
          v-select(
            item-value="key"
            :label="$t('base.select_lang')"
            :options="languages"
            v-model="form.profile.language")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onUpdate") {{ 'base.save' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SettingsClientModal',

  props: {
    item: Object
  },

  data: () => ({
    form: {
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      phone: '',
      user_type: '',
      company_name: '',
      profile: {
        language: null
      }
    },
    languages: [
      { id: 0, name: 'English', key: 'en' },
      { id: 1, name: 'Українська', key: 'uk' },
      { id: 2, name: 'Русский', key: 'ru' },
      { id: 3, name: 'Polish', key: 'pl' },
      { id: 4, name: 'Nederlands', key: 'nl' },
      { id: 5, name: 'Deutschland', key: 'de' },
      { id: 6, name: 'France', key: 'fr' },
      { id: 7, name: 'Italia', key: 'it' },
      { id: 8, name: 'România', key: 'ro' },
      { id: 9, name: 'USA', key: 'us' },
    ],
    loading: false
  }),

  computed: {
    ...mapGetters('dashboard', [
      'currentUser'
    ])
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('dashboard', [
      'updateUser',
      'updateClient'
    ]),

    loadData () {
      this.form.user_type = this.currentUser.user_type
      this.form.first_name = this.currentUser.first_name
      this.form.last_name = this.currentUser.last_name
      this.form.phone = this.currentUser.phone
      this.form.email = this.currentUser.email
      this.form.company_name = this.item.display_name
      this.form.profile.language = this.currentUser.profile.language
    },

    async onUpdate () {
      const payload = {
        id: this.currentUser.id,
        email: this.form.email,
        password: this.form.password,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        phone: this.form.phone,
        user_type: this.form.user_type,
        profile: {
          language: this.form.profile.language,
        }
      }
      const data = {
        display_name: this.form.company_name
      }
      this.loading = true
      const errors = await this.updateUser(payload)
      if (this.form.company_name) {
        await this.updateClient({ id: this.item.id, data })
      }
      this.loading = false
      if (!errors) {
        this.$emit('close')
      } else {
        if (errors.email) {
          this.$toasted.show('Incorrect email!')
        } else {
          if (errors.phone) {
            this.$toasted.show('Incorrect phone!')
          } else {
            this.$toasted.show('Something want wrong!')
          }
        }
      }
    }
  }
}
</script>
